import React, { useCallback, useEffect, useState } from "react";
import {
  DocotorIcon,
  DocotorPairIcon,
} from "../../assets/common-svg/CommonSvg";
import SubjectApi from "../../services/subjectService.js";
import CustomTable from "../../components/custom-table/CustomTable";
import { CustomCard } from "../../components/custom-card/CustomCard";
import { useLocation, useNavigate, useParams } from "react-router";
import SkeletonLoader from "../../utilites/SkeltonLoader";
import { editorManagementDetailData } from "../../utils/tableData";
import BreadCrumb from "../breadcrumb/BreadCrumb";
import SubAdminApi from "../../services/subAdminService";
import EditorApi from "../../services/editorManagementService.js";
import DeleteConfirmContent from "../../components/modal-contents/DeleteConfirmModalContent.js";
import EditorManagementEdit from "../editor-management-edit/EditorManagementEdit.js";
import moment from "moment";
import { notify } from "../../bmr/utils/methods/notification.js";

export const convertSubjectData = (data,curr_page, page_details, order) => {
  return data?.map((sub, index) => {
    let SerialNo = order=='desc'? (page_details?.no_of_records-((curr_page-1)*10))-index : index+1+((curr_page-1)*10); 
    let transformedPatientId = sub?.patient_id || "--";
    let transformedSubjectInitial = sub?.first_name + " " + sub?.last_name || "";
    let transformedPatientStatus =
      sub?.life_status == "lost" ? (
        <div className="h-3 w-3 rounded-full bg-yellow-500"></div>
      ) : sub?.life_status == "alive" ? (
        <div className="h-3 w-3 rounded-full bg-green-500"></div>
      ) : (
        <div className="h-3 w-3 rounded-full bg-red-500"></div>
      )
    let transformedLastVisitType = sub?.last_visit_type || "--"
    let transformePhaseName = sub?.phase_name || "";
    let transformedAppointmentCount = sub?.appointmentCount || 0;
    let transformCycleCount = sub?.cycle || 0;
    let stage = sub?.apheresis_status || ''
    let gender = sub?.gender || "";
    let lastAppointmentDate = sub?.last_appointment_date ? moment(sub?.last_appointment_date).format("DD/MM/YYYY") : "--";
    let id = sub?.id || "";
    return [
      SerialNo,
      transformedPatientId,
      transformedSubjectInitial,
      transformedPatientStatus,
      transformedLastVisitType,
      transformePhaseName,
      transformedAppointmentCount,
      stage,
      transformCycleCount,
      gender,
      lastAppointmentDate,
      id,
    ];
  });
};

export const EditorManagementDetails = ({loadExtraApi = true, investigatorId='', editorData={}}) => {
  const [loading, setLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [loadingDropdown, setLoadingDropdown] = useState(false);
  const [editorDetailedData, setEditorDetailedData] = useState(editorData);
  const [tableFilters, setTablesFilters] = useState({ searchData: "" });
  const [totalPage, setTotalPage] = useState(1);
  const [currentPage, setCurrentpage] = useState(1);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [phaseListData, setPhaseListData] = useState(null);
  const [phaseID, setPhaseID] = useState(null);
  const [piList, setPiList] = useState([]);
  const [piId, setPiId] = useState(investigatorId)
  const [orderBy,setOrderBy] = useState('');
  const [order,setOrder] = useState('desc');
  const [phaseTable, setPhaseTable] = useState([])
  const [openDeleteConfirmModal, setOpenDeleteConfirmModal] =
    React.useState(false);
  const [subjectData, setSubjectData] = useState(editorManagementDetailData);
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();

  const handleNavigateToDetails = useCallback((row) => {
    const UpdatedNavigationArray = location.state;
    UpdatedNavigationArray?.push({
      name: "Patient Details",
      path: `${location.pathname}/patient-details/${row[row.length - 1]}`,

    });
    navigate(`patient-details/${row[row.length - 1]}`, {
      state: UpdatedNavigationArray,
    });
  }, []);

  const getSubAdminDetails = async () => {
    setLoading(true);
    try {
      const res = await SubAdminApi.getSubAdminDetails(id);
      setEditorDetailedData(res?.data || {});
      setPiId(res?.data?.investigator_details?.id) 
    } catch (error) {
       notify.error(error)
    } finally {
      setLoading(false);
    }
  };

  useEffect(()=> {
 if(loadExtraApi)
   getSubAdminDetails();
  },[loadExtraApi])
  
  useEffect(() => {
    getPersonalInvestigatorList()
    getPhaseDropTable()
  }, []);

  const getPhaseDropTable = async () => {
    try {
      const res = await EditorApi.getPhaseDropDown("", "", id);
      const data = res?.data?.map((val) => ({
        id: val.id,
        name: val.title,
      }));
      setPhaseTable(data);
    } catch (error) {
        notify.error(error)
    }
  };

  const GetMatchedKey = (key)=>{
    switch (key.trim().toLowerCase()) {
      case 's.no':{
        return 'created_at'
      }    
      case 'patient id':{
        return 'patient_id'
      }    
      case 'patient name':{
        return 'name'
      }    
      case 'patient status':{
        return 'life_status'
      }    
      case 'last recorded visit':{
        return 'last_visit_type'
      }    
      case 'investigator':{
        return 'investigator'
      }    
      case 'editor':{
        return 'editor'
      }  
      case 'phase':{
        return 'phase_name'
      } 
      case 'appointment completed':{
        return 'appointmentCount'
      }   
      case 'cycle no.':{
        return 'cycle'
      }    
      default:
        return '';
    }
  }


  async function getSubjectList() {
    const sortBy = GetMatchedKey(orderBy);
    try {
      const res = await SubjectApi.getSubjectList(
        phaseID,
        currentPage,
        10,
        tableFilters?.searchData,
        id,
        piId,
        "",
        "",
        sortBy,
        order
      );
      let rowData = convertSubjectData(res?.data || [],currentPage, res?.page_details, order);
      setSubjectData((prev) => ({
        ...prev,
        rows: [...rowData],
      }));
      setTotalPage(
        Math.ceil(res?.page_details?.no_of_records / res?.page_details?.limit)
      );
      setCurrentpage(res?.page_details?.page);
      setLoadingDropdown(false);
    } catch (error) {
     notify.error(error)
    }
  }

  const handlePagination = async (value) => {
    setCurrentpage(value);
  };

  const handleTableFilters = (e) => {
    setTablesFilters({ ...tableFilters, searchData: e });
  };

 useEffect(() => {
  if (piId && tableFilters?.searchData[tableFilters?.searchData?.length - 1] != " "
  ) {
    setLoadingDropdown(true);
    getSubjectList();
  }
}, [currentPage, tableFilters, id, phaseID, piId]);


  const getPhase = async () => {
    try {
      const res = await EditorApi.getPhaseDropDown("", piId);
      const data = res?.data?.map((val) => ({
        id: val.id,
        name: val.title,
      }));
      setPhaseListData(data);
    } catch (error) {
 notify.error(error)
    }
  };

  useEffect(() => {
    getPhase();
  }, [piId]);

  const handleDropDownChange = (e) => {
    setPhaseID(e.target.value);
  };
  const handleDeleteRow = async () => {
    setOpenDeleteConfirmModal(false);
    setSubmitLoading(true);
    try {
      const res = await EditorApi.deleteEditor(id);
      if (res?.status === 200) {
        setSubmitLoading(false);
         notify.success(res?.message)
        navigate("/editor-management", { state: [] });
      }
    } catch (error) {
      setSubmitLoading(false);
 notify.error(error)    }
  };
  const getPersonalInvestigatorList = () =>
    EditorApi.subadminDropDown()
      .then((res) => {
        setPiList(res.data);
      })
      .catch((error) => {
 notify.error(error)
      });

  const handleSort = (property)=>{
        const isAsc = orderBy === property && order === 'asc'; // On same column click change order
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
      }
    
      useEffect(()=>{
        if(orderBy){
          getSubjectList();
        }
      },[orderBy,order])

      return (
    <div className="p-2 pt-4 bg-[#F0F1F5]">
      <div className="mb-4 pl-3">
        <BreadCrumb BreadCrumbsListing={
          [
            {
              name: 'Onboard Users',
              path: 'onboard-users'
            },
            {
              name: 'Details',
              path: location.pathname
            }
          ]
        } />
      </div>

      <div className="pl-3 pr-3">
        {" "}
        {loading ? (
          <div className="col-start-1 col-end-4 ">
            <SkeletonLoader rowCount={1} isTable={false} height={160} />
          </div>
        ) : (
          <>
            {" "}
            <CustomCard
              editAuth={{ module: "editorManage", auth: 60 }}
              deleteAuth={{ module: "editorManage", auth: 61 }}
              MainHeading={editorDetailedData?.name}
              SubHeading={`${editorDetailedData?.email || ""}  |  ${editorDetailedData?.role || ""
                }`}
              main_heading_class={"font-bold"}
              NoWrap={true}
              DetailsArray={[
                {
                  FieldName: "Assigned Phases",
                  Value: editorDetailedData?.phaseCount,
                },
                {
                  FieldName: "Principal Investigator/HCP",
                  Value: editorDetailedData?.investigator_details?.name || "",
                },
              ]}
              startIcon={<DocotorIcon Height="50px" Width="52px" />}
              endIcon={<DocotorPairIcon />}
              ArrayLowGapBoolean={true}
              chartData={editorDetailedData?.phaseDetails || []}
              handleEdit={() => setOpenEditModal(true)}
              handleDelete={() => setOpenDeleteConfirmModal(true)}
            />{" "}
          </>
        )}
      </div>
      {openEditModal ? (
        <EditorManagementEdit
          openModal={openEditModal}
          setOpenModal={setOpenEditModal}
          id={id}
          editorDetailedData={editorDetailedData}
          phaseList={phaseListData}
          piList={piList}
          getSubAdminDetails={getSubAdminDetails}
          setPiId={setPiId}
        />
      ) : null}
      <CustomTable
        rows={subjectData?.rows}
        columnAlign={subjectData?.columnAlign}
        columns={subjectData?.columns}
        TableData={subjectData?.TableData}
        handleNavigate={handleNavigateToDetails}
        handleTableFilters={handleTableFilters}
        tableFilters={tableFilters}
        handleChangePage={handlePagination}
        loading={loadingDropdown}
        currentPage={currentPage}
        totalpage={totalPage}
        MenuList={phaseTable}
        dropDownValue={phaseID}
        handleChangeDropDown={handleDropDownChange}
        order={order}
        orderBy={orderBy}
        EnableSorting={true}
        handleSort ={handleSort}
      />
      <DeleteConfirmContent
        open={openDeleteConfirmModal}
        setOpen={setOpenDeleteConfirmModal}
        handleCancel={() => setOpenDeleteConfirmModal(false)}
        handleDelete={handleDeleteRow}
        isLoading={submitLoading}
      />
    </div>
  );
};
